// Contexte fixe seulement : jamais de nom, de valeur ni d'extrait de la carte dans le retour.
import { lienVers } from '../routeur';

export function LienRetour({ depuis }: { depuis: 'console' | 'constat' | 'chiffre' | 'chiffre-console' }) {
  return <a className="btn petit" href={lienVers('retours', { depuis })}>
    {depuis.startsWith('chiffre') ? 'Contester ce chiffre' : depuis === 'constat' ? 'Signaler un manque sur ce constat' : 'Signaler ce qui manque'}
  </a>;
}
